import React, { Fragment, useState, useContext, useEffect } from "react";
import {
  Grid,
  Typography,
  IconButton,
  Button,
  Divider,
  Card,
  Tooltip,
} from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import { makeStyles } from "@material-ui/core/styles";

import Spinner from "../../layout/Spinner";

import PaymentContext from "../../../context/paypal/payments/PaymentContext";
import PaymentActionModal from "./PaymentActionModal";

const PaymentDetails = ({ openDetails }) => {
  const paymentContext = useContext(PaymentContext);
  const { getDetails, details, returned_info, returned_posting, error } =
    paymentContext;
  const [confirmModal, setConfirmModal] = useState(false);
  const [action, setAction] = useState("");
  const [actionDisplay, setActionDisplay] = useState(true);
  const useStyles = makeStyles((theme) => ({
    card: {
      backgroundColor: "#FFFFFF",
      padding: theme.spacing(2),
      height: "100%",
    },
    buttonOutline: {
      "&:focus": {
        outline: "none",
      },
    },
  }));

  const classes = useStyles();

  const [state, setState] = useState();
  const [copiedID, setCopiedID] = useState(false);
  const [postOrderData, setPostOrderData] = useState("");

  //Convert String to Camel Case
  const camelCaseFormat = (str) => {
    let str_split = str.toLowerCase().split("_");
    for (let i = 0; i < str_split.length; i++) {
      str_split[i] =
        str_split[i].charAt(0).toUpperCase() + str_split[i].substring(1);
    }
    return str_split.join(" ");
  };

  useEffect(() => {
    getDetails(openDetails.id, openDetails.payment_type);
    setPostOrderData("");
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getDetails(openDetails.id, openDetails.payment_type);
    //eslint-disable-next-line
  }, [returned_info]);

  useEffect(() => {
    if (details) {
      const products = [];
      let discount = 0;
      let payment_type = "N/A";
      let purchase_total = 0;
      let shipping_amount = 0;
      let paypal_fee = openDetails.fee.split("-");
      let gateway = "N/A";
      let order_name = "N/A";
      if (returned_posting && returned_posting.order_name) {
        order_name = returned_posting.order_name;
        setActionDisplay(false);
      } else {
        order_name = details.order_name;
      }
      if (openDetails.payment_type === "PAYPAL_BILLING_AGREEMENT") {
        payment_type = "Paypal Billing Agreement";
        gateway = "BillingAgreement";
      } else if (openDetails.payment_type === "PAYPAL_EXPRESS") {
        payment_type = "Paypal Express";
        gateway = "PaypalExpress";
        // set express token to pass to Modal
        if (details.express_token) {
          setPostOrderData(details.express_token);
        }
      } else if (openDetails.payment_type === "VISA") {
        payment_type = "Visa Card";
        gateway = "PaypalUccs";
      } else if (openDetails.payment_type === "MASTER") {
        payment_type = "Master Card";
        gateway = "PaypalUccs";
      }

      if (details.discount) {
        discount = details.discount;
      }
      // Set line_items
      if (details.line_items.length > 0) {
        for (let x in details.line_items) {
          var product_name = "N/A";
          var sku = "N/A";
          var quantity = details.line_items[x].quantity;
          var price = (
            parseFloat(details.line_items[x].per_item_price) *
            parseFloat(quantity)
          ).toFixed(2);
          if (details.line_items[x].product_title) {
            product_name = details.line_items[x].product_title;
          }
          if (details.line_items[x].sku) {
            sku = details.line_items[x].sku;
          }
          purchase_total += parseFloat(price);
          products.push({
            product_name: product_name,
            product_sku: sku,
            product_quantity: quantity,
            product_price: price,
          });
        }
      }
      if (openDetails.shopify === "Unmatched") {
        shipping_amount = (
          parseFloat(openDetails.gross) +
          parseFloat(discount) -
          parseFloat(purchase_total)
        ).toFixed(2);
      } else if (openDetails.shopify === "Matched") {
        shipping_amount = details.shipping_amount;
      }
      setState({
        gateway: gateway,
        order_name: order_name,
        transaction_id: openDetails.id,
        payment_date: openDetails.create_time,
        payment_status: camelCaseFormat(openDetails.status),
        payment_type: payment_type,
        full_name: details.full_name,
        email: details.email,
        shipping_address: details.shipping_address,
        products: products,
        purchase_total: parseFloat(purchase_total).toFixed(2),
        shipping_amount: shipping_amount,
        discount_amount: parseFloat(discount).toFixed(2),
        gross_amount: openDetails.gross,
        paypal_fee: paypal_fee[1],
        net_amount: openDetails.net,
      });
    }
    //eslint-disable-next-line
  }, [details, returned_posting]);

  const onActionClick = (actions) => {
    setAction(actions);
    setConfirmModal(true);
  };

  return (
    <Fragment>
      {" "}
      {state && openDetails.id === details.payment_id ? (
        <Grid
          container
          direction="row"
          spacing={3}
          alignItems="stretch"
          style={{
            height: 620,
          }}
        >
          <Grid item xs={3}>
            <Grid
              container
              direction="row"
              alignItems="stretch"
              style={{
                height: "100%",
              }}
            >
              <Grid item xs={12}>
                <Card className={classes.card}>
                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={7}>
                      <Typography variant="subtitle2">
                        <strong> Gateway </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={5}>
                      <Typography variant="subtitle2">
                        <strong> Order Name </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={7}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          color: "#666666",
                        }}
                      >
                        {state.gateway}{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={5}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          color: "#666666",
                        }}
                      >
                        {state.order_name}{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        <strong> Transaction </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItems="flex-end"
                      >
                        <Grid item>
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            {state.transaction_id}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item>
                          <CopyToClipboard
                            text={state.transaction_id}
                            onCopy={() => {
                              setCopiedID(true);
                            }}
                          >
                            <Tooltip
                              title={copiedID ? "Copied!" : ""}
                              placement="top"
                            >
                              <IconButton
                                size="small"
                                className={classes.buttonOutline}
                                style={
                                  copiedID
                                    ? {
                                        color: "#888888",
                                      }
                                    : {
                                        color: "#999999",
                                      }
                                }
                              >
                                <FileCopyIcon fontSize="small" />
                              </IconButton>{" "}
                            </Tooltip>{" "}
                          </CopyToClipboard>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                </Card>{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                {" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Card className={classes.card}>
                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        <strong> Payment </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            {state.payment_date}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            {state.payment_status}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            {state.payment_type}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                </Card>{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                {" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Card className={classes.card}>
                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        <strong> Customer Information </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            {state.full_name}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Typography
                            variant="subtitle2"
                            style={{
                              color: "#666666",
                            }}
                          >
                            {state.email}{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        <strong> Shipping Address </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Grid container direction="row">
                        {" "}
                        {state.shipping_address.address1 ? (
                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle2"
                              style={{
                                color: "#666666",
                              }}
                            >
                              {state.shipping_address.address1}{" "}
                            </Typography>{" "}
                          </Grid>
                        ) : null}{" "}
                        {state.shipping_address.address2 ? (
                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle2"
                              style={{
                                color: "#666666",
                              }}
                            >
                              {state.shipping_address.address2}{" "}
                            </Typography>{" "}
                          </Grid>
                        ) : null}{" "}
                        {state.shipping_address.city ||
                        state.shipping_address.zip ? (
                          <Grid item xs={12}>
                            <Grid container direction="row" spacing={1}>
                              {" "}
                              {state.shipping_address.city ? (
                                <Grid item>
                                  <Typography
                                    variant="subtitle2"
                                    style={{
                                      color: "#666666",
                                    }}
                                  >
                                    {state.shipping_address.city}{" "}
                                  </Typography>{" "}
                                </Grid>
                              ) : null}{" "}
                              {state.shipping_address.zip ? (
                                <Grid item>
                                  <Typography
                                    variant="subtitle2"
                                    style={{
                                      color: "#666666",
                                    }}
                                  >
                                    {state.shipping_address.zip}{" "}
                                  </Typography>{" "}
                                </Grid>
                              ) : null}{" "}
                            </Grid>{" "}
                          </Grid>
                        ) : null}{" "}
                        {state.shipping_address.province ? (
                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle2"
                              style={{
                                color: "#666666",
                              }}
                            >
                              {state.shipping_address.province}{" "}
                            </Typography>{" "}
                          </Grid>
                        ) : null}{" "}
                        {state.shipping_address.country ? (
                          <Grid item xs={12}>
                            <Typography
                              variant="subtitle2"
                              style={{
                                color: "#666666",
                              }}
                            >
                              {state.shipping_address.country}{" "}
                            </Typography>{" "}
                          </Grid>
                        ) : null}{" "}
                      </Grid>{" "}
                    </Grid>{" "}
                    {state.shipping_address === "N/A" ? (
                      <Grid item xs={12}>
                        <Typography
                          variant="subtitle2"
                          style={{
                            color: "#666666",
                          }}
                        >
                          {state.shipping_address}{" "}
                        </Typography>{" "}
                      </Grid>
                    ) : null}{" "}
                  </Grid>{" "}
                </Card>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid item xs={9}>
            <Grid
              container
              direction="row"
              alignItems="stretch"
              style={{
                height: "100%",
              }}
            >
              <Grid item xs={12}>
                <Card className={classes.card}>
                  <Grid container direction="row" spacing={1}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle2">
                        <strong> Order Details </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                    <Grid item xs={5}>
                      <Typography variant="subtitle2"> Product </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={3}>
                      <Typography variant="subtitle2"> SKU </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={2}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          float: "right",
                        }}
                      >
                        Quantity{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={2}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          float: "right",
                        }}
                      >
                        Price{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                    <Grid item xs={12}>
                      {" "}
                      {state.products.map((each, index) => {
                        return (
                          <Grid container direction="row" key={index}>
                            <Grid item xs={5}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                }}
                              >
                                {each.product_name}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={3}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                }}
                              >
                                {each.product_sku}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={2}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                  float: "right",
                                }}
                              >
                                {each.product_quantity}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={2}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                  float: "right",
                                }}
                              >
                                $ {each.product_price}
                                USD{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                          </Grid>
                        );
                      })}{" "}
                    </Grid>{" "}
                    <Grid item xs={12}>
                      <Divider variant="fullWidth" />
                    </Grid>{" "}
                    <Grid item xs={10}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          float: "right",
                        }}
                      >
                        <strong> Purchase Total </strong>{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                    <Grid item xs={2}>
                      <Typography
                        variant="subtitle2"
                        style={{
                          color: "#666666",
                          float: "right",
                        }}
                      >
                        $ {state.purchase_total}
                        USD{" "}
                      </Typography>{" "}
                    </Grid>{" "}
                  </Grid>{" "}
                </Card>{" "}
              </Grid>{" "}
              <Grid item xs={12}>
                {" "}
              </Grid>{" "}
              <Grid item xs={12}>
                <Grid
                  container
                  direction="row"
                  style={{
                    height: "100%",
                  }}
                >
                  <Grid
                    item
                    style={
                      openDetails.shopify === "Unmatched" && actionDisplay
                        ? {
                            width: "59%",
                          }
                        : {
                            width: "100%",
                          }
                    }
                  >
                    <Card className={classes.card}>
                      <Grid container direction="row" spacing={1}>
                        <Grid item xs={12}>
                          <Typography variant="subtitle2">
                            <strong> Payment Details </strong>{" "}
                          </Typography>{" "}
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Divider variant="fullWidth" />
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Grid container direction="row">
                            <Grid item xs={7}>
                              <Typography variant="subtitle2">
                                Purchase Total{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={5}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                  float: "right",
                                }}
                              >
                                $ {state.purchase_total}
                                USD{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={7}>
                              <Typography variant="subtitle2">
                                Shipping Amount{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={5}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                  float: "right",
                                }}
                              >
                                $ {state.shipping_amount}
                                USD{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={7}>
                              <Typography variant="subtitle2">
                                Discount Amount{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={5}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                  float: "right",
                                }}
                              >
                                -$ {state.discount_amount}
                                USD{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                          </Grid>{" "}
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Divider variant="fullWidth" />
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Grid container direction="row">
                            <Grid item xs={7}>
                              <Typography variant="subtitle2">
                                Gross Amount{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={5}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                  float: "right",
                                }}
                              >
                                $ {state.gross_amount}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={7}>
                              <Typography variant="subtitle2">
                                PayPal Fee{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={5}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  color: "#666666",
                                  float: "right",
                                }}
                              >
                                -$ {state.paypal_fee}{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                          </Grid>{" "}
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Divider variant="fullWidth" />
                        </Grid>{" "}
                        <Grid item xs={12}>
                          <Grid container direction="row">
                            <Grid item xs={7}>
                              <Typography variant="subtitle2">
                                Net Amount{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                            <Grid item xs={5}>
                              <Typography
                                variant="subtitle2"
                                style={{
                                  float: "right",
                                }}
                              >
                                <strong> $ {state.net_amount} </strong>{" "}
                              </Typography>{" "}
                            </Grid>{" "}
                          </Grid>{" "}
                        </Grid>{" "}
                      </Grid>{" "}
                    </Card>{" "}
                  </Grid>{" "}
                  {openDetails.shopify === "Unmatched" && actionDisplay ? (
                    <Grid
                      item
                      style={{
                        width: "2%",
                      }}
                    >
                      {" "}
                    </Grid>
                  ) : null}{" "}
                  {openDetails.shopify === "Unmatched" && actionDisplay ? (
                    <Grid
                      item
                      style={{
                        width: "39%",
                      }}
                    >
                      <Card className={classes.card}>
                        <Grid
                          container
                          direction="row"
                          spacing={1}
                          alignItems="stretch"
                        >
                          <Grid item xs={12}>
                            <Typography variant="subtitle2">
                              <strong> Actions </strong>{" "}
                            </Typography>{" "}
                          </Grid>{" "}
                          <Grid item xs={12}>
                            <Divider variant="fullWidth" />
                          </Grid>{" "}
                          <Grid item xs={12}>
                            <Grid
                              container
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Grid item>
                                <Typography variant="subtitle2">
                                  Edit Customer Information{" "}
                                </Typography>{" "}
                              </Grid>{" "}
                              <Grid
                                item
                                style={{
                                  width: "25%",
                                }}
                              >
                                <Button
                                  variant="outlined"
                                  className={classes.buttonOutline}
                                  fullWidth
                                  onClick={() => onActionClick("edit_customer")}
                                >
                                  Edit{" "}
                                </Button>{" "}
                              </Grid>{" "}
                            </Grid>{" "}
                          </Grid>{" "}
                          {state.gateway === "PaypalExpress" ? (
                            <Grid item xs={12}>
                              <Grid
                                container
                                direction="row"
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                <Grid item>
                                  <Typography variant="subtitle2">
                                    Perform Order Posting{" "}
                                  </Typography>{" "}
                                </Grid>{" "}
                                <Grid
                                  item
                                  style={{
                                    width: "25%",
                                  }}
                                >
                                  <Button
                                    variant="outlined"
                                    className={classes.buttonOutline}
                                    fullWidth
                                    onClick={() =>
                                      onActionClick("order_posting")
                                    }
                                  >
                                    Post{" "}
                                  </Button>{" "}
                                </Grid>{" "}
                              </Grid>{" "}
                            </Grid>
                          ) : null}{" "}
                          <PaymentActionModal
                            confirmModal={confirmModal}
                            setConfirmModal={setConfirmModal}
                            action={action}
                            transaction_id={state.transaction_id}
                            email={state.email}
                            postOrderData={postOrderData}
                          />{" "}
                        </Grid>{" "}
                      </Card>{" "}
                    </Grid>
                  ) : null}{" "}
                </Grid>{" "}
              </Grid>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Grid>
      ) : (
        <Grid
          container
          direction="row"
          alignItems="center"
          justifyContent="center"
          style={{
            height: 610,
          }}
        >
          <Grid item>
            <Spinner />
          </Grid>{" "}
        </Grid>
      )}{" "}
    </Fragment>
  );
};

export default PaymentDetails;
